
import React, { Component } from 'react';
import ModalVideo from 'react-modal-video';
import Slider from 'react-slick';
import Link from 'next/link';
import Img from '../../Img';
import { LinkAnchor } from '../../Links';

import styles from './hero.module.scss';

const Slide = (props) => {
    const { slide, authed, key } = props;
    const desktopBg = slide.image && slide.image.desktop;
    const mobileBg = slide.image && slide.image.mobile;
    const captions = slide.heroImageDetails && slide.heroImageDetails.captions ? slide.heroImageDetails.captions : [];
    const bgOpacity = slide.overlay_percent ? `0.${100 - parseInt(slide.overlay_percent)}` : '1';

    const bgImg = (imageObj) => {
        if (imageObj && imageObj.oneX && imageObj.twoX && imageObj.threeX) {
            return (
                <Img
                    useRawSrcSet={true}
                    src={imageObj.oneX}
                    srcSet={`${imageObj.twoX} 2x, ${imageObj.threeX} 3x`}
                    style={{ left: '0%' }}
                />
            );
        } if (imageObj && imageObj.default) {
            return (
                <Img
                    src={imageObj.default}
                    style={{ left: '0%' }}
                />
            );
        }
        return null;
    };
    return (
        <div className="p-rel" key={key}>
            <div className="container">
                <div className={`${styles.hero} ${authed ? 'authed' : ''}`}>
                    <div className="row">
                        <div className="col-sm-10 offset-sm-1 col-md-12 offset-md-0 ">
                            <div className={styles.heroContent}>
                                <div className="text-highlight1 text-highlight-green fs13">
                                    {slide.topline}
                                </div>
                                <h1 className={`${styles.title}`} style={{ color: slide.maintitlecolor }} dangerouslySetInnerHTML={{ __html: slide.maintitle }} />
                                <div className={`text-medium ${styles.heroText}`} style={{ color: slide.subtitlecolor }} dangerouslySetInnerHTML={{ __html: slide.subtitle }} />
                                <LinkAnchor
                                    href={slide.primaryctalink}
                                >
                                    <div className={`btn btn-primary btn-lg text-white ${styles.joinBtn} text-uppercase`}>
                                        {slide.primaryctacopy}
                                    </div>
                                </LinkAnchor>
                                {slide.secondaryctacopy && (
                                    <LinkAnchor
                                        href={slide.secondaryctalink}
                                    >
                                        <div className={`btn btn-primary btn-lg text-white ${styles.joinBtn} text-uppercase`}>
                                            {slide.secondaryctacopy}
                                        </div>
                                    </LinkAnchor>
                                )}
                                <div className={`${styles.heroLinkWrapper}`}>
                                    <div
                                        className={`${styles.heroLink} ${styles.br} ${styles.hasIcon}`}
                                        style={{ color: slide.utrvideolinkcolor, borderColor: slide.utrvideolinkcolor }}
                                        onClick={() => {
                                            props.openmodal('video1');
                                        }}
                                    > <i className={styles.videoPlay} /> What is utr?
                                    </div>
                                    <Link
                                        href="/how-utr-works"
                                    >
                                        <a
                                            className={`${styles.heroLink}`}
                                            style={{ color: slide.utrvideolinkcolor }}
                                        >
                                            How it works
                                        </a>
                                    </Link>
                                </div>
                                {/* <div className={`${styles.cta}`}> */}
                                {/* <div className={`${styles.ctaText}`}>UTR Community Platform Launching Fall 2018</div> */}
                                {/* <a className={`btn btn-primary btn-xl ${styles.joinBtn}`} onClick={this.scrollTo} href="">GET EARLY ACCESS</a> */}
                                {/* </div> */}
                                <div className={styles.caption}>
                                    <p className="text-small">
                                        {captions.map((caption, i) => {
                                            if (caption && caption.trim() !== '') {
                                                return (
                                                    <React.Fragment
                                                        key={`caption-${i}`}
                                                    >
                                                        {caption.trim()}
                                                        {(captions.length > 0 && captions.length - 1 !== i) && (
                                                            <br />
                                                        )}
                                                    </React.Fragment>
                                                );
                                            }
                                            return null;
                                        })}
                                    </p>
                                </div>
                            </div>
                            {slide.image_caption && (
                                <div
                                    className={`text-white ${styles.heroCaption}`}
                                >
                                    {slide.image_caption}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${styles.backgroundWrapper} ${props.authed ? 'authed' : ''}`}>
                <picture className={`${styles.img} d-none d-sm-block`} style={{ opacity: bgOpacity }}>
                    {bgImg(desktopBg)}
                </picture>
                <picture className={`${styles.img} d-block d-sm-none`} style={{ opacity: bgOpacity }}>
                    {bgImg(mobileBg)}
                </picture>
                <div className={styles.backgroundOverlay} />
            </div>
        </div>
    );
};

class Hero extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
        };
        this.openModal = this.openModal.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
    }

    scrollTo(e) {
        e.preventDefault();
        // Scroll to a certain element
        document.getElementById('nextlevel-scrollto').scrollIntoView({
            behavior: 'smooth',
            alignToTop: true,
            block: 'start',
        });
    }

    openModal(video) {
        this.setState({ isOpen: video });
    }

    render() {
        const { slides = [] } = this.props;
        const settings = {
            appendDots: dots => (
                <div>
                    <div className={`container`}>
                        <div className={`row`}> {dots} </div>
                    </div>
                </div>
            ),
            customPaging(i) {
                return (
                    <div className={`button-wrapper`}>
                        <span>{slides[i].sectiontitle}</span>
                    </div>
                );
            },
            arrows: false,
            dots: true,
            dotsClass: 'slick-buttons',
            infinite: true,
            speed: 1000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 8000,
            initialSlide: 0,
        };

        return (
            <div>
                <ModalVideo channel="youtube" isOpen={this.state.isOpen === 'video1'} videoId="maJS-0kOwSo" autoplay={true} onClose={() => this.setState({ isOpen: false })} />
                <Slider {...settings}>
                    {slides.map((slide, i) => {
                        return <Slide key={`slide${i}`} slide={slide} openmodal={this.openModal} />;
                    })}
                </Slider>
            </div>
        );
    }
}

export default Hero;
